import React from 'react';
import { Row, Col, Typography, Divider } from 'antd';
import IssueCard from './IssueCard';
const { Title, Text } = Typography;

const ThreadAndChannelLayout = (props) => {
  const hideThreadCard =
    props.tabKey === 'notification'
      ? props.notificationShowFullIssueCard &&
        props.notificationDisplayFormat !== 'detailed'
        ? false
        : true
      : false;
  return (
    <>
      {props.tabKey === 'notification' ? (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            overflowX: 'hidden',
          }}
        >
          <div style={{ width: '49%', padding: '8px' }}>
            <div style={{ borderBottom: '0.5px solid #D9D9D9' }}>
              <Title level={5}>#Channel</Title>
            </div>
            {props.tabKey === 'notification' && (
              <IssueCard viewType='channel' {...props} />
            )}
          </div>
          <div style={{ width: '0.5px', backgroundColor: '#D9D9D9' }}></div>
          <div style={{ width: '49%', padding: '8px' }}>
            <div style={{ borderBottom: '0.5px solid #D9D9D9' }}>
              <Title level={5}>Thread</Title>
            </div>
            {!hideThreadCard && <IssueCard viewType='thread' {...props} />}
          </div>
        </div>
      ) : (
        <IssueCard {...props} />
      )}
    </>
  );
};

export default ThreadAndChannelLayout;
